/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscountBXGY
 */
export interface DiscountBXGY {
    /**
     * Type of discount
     * @type {string}
     * @memberof DiscountBXGY
     */
    discountType: DiscountBXGYDiscountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof DiscountBXGY
     */
    buyQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof DiscountBXGY
     */
    getQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof DiscountBXGY
     */
    quantityFrom?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscountBXGY
     */
    quantityTo?: number;
}


/**
 * @export
 */
export const DiscountBXGYDiscountTypeEnum = {
    Bxgy: 'bxgy'
} as const;
export type DiscountBXGYDiscountTypeEnum = typeof DiscountBXGYDiscountTypeEnum[keyof typeof DiscountBXGYDiscountTypeEnum];


/**
 * Check if a given object implements the DiscountBXGY interface.
 */
// @ts-ignore
export function instanceOfDiscountBXGY(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "discountType" in value;
    isInstance = isInstance && "buyQuantity" in value;
    isInstance = isInstance && "getQuantity" in value;

    return isInstance;
}

// @ts-ignore
export function DiscountBXGYFromJSON(json: any): DiscountBXGY {
    return DiscountBXGYFromJSONTyped(json, false);
}

// @ts-ignore
export function DiscountBXGYFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscountBXGY {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'discountType': json['discount_type'],
        'buyQuantity': json['buy_quantity'],
        'getQuantity': json['get_quantity'],
        'quantityFrom': !exists(json, 'quantity_from') ? undefined : json['quantity_from'],
        'quantityTo': !exists(json, 'quantity_to') ? undefined : json['quantity_to'],
    };
}

// @ts-ignore
export function DiscountBXGYToJSON(value?: DiscountBXGY | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'discount_type': value.discountType,
        'buy_quantity': value.buyQuantity,
        'get_quantity': value.getQuantity,
        'quantity_from': value.quantityFrom,
        'quantity_to': value.quantityTo,
    };
}

